export const primaryColor = '#28a745'
export const dangerColor = '#dc3545'
